import React from 'react';
import debounce from 'lodash/debounce';
import {
  ThemeProvider, Modal, ModalWrapper, ModalHeader, ModalContent, Textfield,
  Textarea
} from '@workboard/wobo-ui';
import styled from 'styled-components'
import GoalServices from '../services/goal.services';
import { radioGroupHelper } from '../utils/radio-helper';
import { KeyDownEvent } from '../utils/eventKey';
import { withTranslation } from 'react-i18next';

const StyledModal = styled(Modal)`
  ${ModalWrapper} { 
    width: 902px;
    border-radius: 4px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
  }
  ${ModalHeader} { 
    padding: 10px 20px !important;
    h1 {
      font-size: 16px !important;
    }
  }
  ${ModalContent} { 
    padding: 0px !important;
    width: 902px;
    height: 350px;
  }
  input[name="tag"], textarea[name="goal"] {
    outline: none !important;
  }
`;

class CreateWsPopUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        Team: [],
      },
      searchTeamEn: false,
      teamSearchText: props.t('Search for teams'),
      team_name: '',
      team_id: '',
      errors: {},
      board_type_0: 1,
      tag: '',
      goal: '',
      for_0: '',
      columnId: 0,
      selectBoard: props.t('Please choose any one board'),
      boardName: props.t('Please enter workstream name '),
      teamPermissionSelected: [],
      teamIdsSelected: [],
      teamNameErr: props.t('Please select the team.'),
      teamSearchVal: '',
    };
    this.closeWorkstream = this.closeWorkstream.bind(this);
    this.filterTeamFunctions = this.filterTeamFunctions.bind(this);
    this.saveWs = this.saveWs.bind(this);
    this.GoalServices = new GoalServices();
    this.handleChange = this.handleChange.bind(this);
    this.onSiteChanged = this.onSiteChanged.bind(this);
    this.selectTeam = this.selectTeam.bind(this);
    this.clickEvent = this.clickEvent.bind(this);
    this.delayedCalleback = debounce(function (event) {
      const _this = this;
      this.setState({ teamSearchVal: event.target.value },
        () => _this.filterTeamFunctions(event)
      );
    }, 300);
    this.changeSearchBox = this.changeSearchBox.bind(this);
    this.radioGroupID = 'radio-btn-group-aE-create-ws';
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.clickEvent, false);
  }

  componentWillUnmount() {
    this.setState({ _isMounted: false });
  }

  changeSearchBox(event) {
    event.persist();
    this.delayedCalleback(event);
  }

  closeWorkstream() {
    console.log('close');
    this.props.closeWsPopUp();
  }

  clickEvent(e) {
    if (!$('.teamSearchs').is(e.target) && $('.teamSearchs').has(e.target).length === 0) {
      if (this.state.searchTeamEn) {
        this.setState({
          searchTeamEn: false,
        });
      }
    }
  }

  onSiteChanged(e, id) {
    this.setState({
      board_type_0: id,
    });
  }

  handleChange(e) {
    // console.log(e.target.value);
    const { name } = e.target;
    const { value } = e.target;
    const { state } = this;
    state[name] = value;
    this.setState(state);
  }

  filterTeamFunctions(event) {
    event.preventDefault();
    let input; let
      filter;
    const _this = this;
    input = document.getElementById('TeamSearch');
    filter = input.value.toLowerCase();
    filter[0] === ' ' ? filter[0].replace(' ', '') : filter;
    filter[filter.length - 1] === ' ' ? filter[filter.length - 1].replace(' ', '') : filter;


    if (filter.length > 1) {
      _this.GoalServices.searchTeamName({ term: filter }).then(
        (response) => {
          if (response.data) {
            _this.setState({
              filter: {
                Team: _this.state.teamSearchVal && _this.state.teamSearchVal.length > 1 ? response.data : [],
              },
            });
          }
        },
      );
    } else {
      _this.setState({
        filter: {
          Team: [],
        },
      });
    }
  }

  selectTeam(event, valTeam) {
    // event.stopPropagation();
    const _this = this;
    // console.log(valTeam, 'VAL');
    _this.setState({
      teamSearchText: valTeam.name,
      for_0: valTeam.id,
      searchTeamEn: false,
    });
  }

  saveWs() {
    const errors = {};
    const _this = this;
    const { columnId } = _this.state;

    const tags = [];
    let fors = [];
    const goals = [];
    const board_types = [];

    const ws = {};

    if (_this.state.tag == '') {
      errors.showTagErr = false;
    }
    if (_this.state.teamIdsSelected && _this.state.teamIdsSelected.length < 1) {
      errors.showTeamErr = false;
    }
    if (_this.state.board_type_0 == '') {
      errors.showBoardErr = false;
    }

    tags.push(_this.state.tag);
    fors = (_this.state.teamIdsSelected);
    goals.push(_this.state.goal);
    board_types.push(_this.state.board_type_0);
    const params = {};
    params.for_0 = fors;
    params.board_type_0 = board_types;
    params.columnId = columnId;
    params.tag = tags;
    params.goal = goals;


    if (Object.keys(errors).length) {
      this.setState({ errors });
    } else {
      _this.GoalServices.createWorkstream(params).then((response) => {
		if(response.data.error){
			alert(response.data.error);
			return false;
		}else{
			renderWsLeftMenu();
			renderLeftMenu('teamPeek');
			try {
			_this.state.teamPermissionSelected.map((val, i) => {
				const MainWS = [];
				MainWS.team_name = val.name;
				MainWS.team_id = val.id;
				MainWS.ws = [{ id: response.data.id, name: _this.state.tag, board_type: _this.state.board_type_0, listOrder: 1}];
				_this.props.closeWsPopUp(MainWS);
			});
			} catch (error) {
			document.getElementById('display').innerHTML = error.message;
			}
		}
      });
    }
  }

  handleAlignChange(event, selectedGoal) {
    event.stopPropagation();
    const existingState = this.state.teamPermissionSelected;
    let result = [];
    const results = [];
    if (existingState.find(val => val.id == selectedGoal.id)) {
      result = existingState.filter(eachVal => eachVal.id != selectedGoal.id);
    } else {
      result = [
        ...existingState,
        selectedGoal,
      ];
    }
    console.log(result);
    result.map(e => results.push(e.id));
    console.log(results);

    this.setState({
      teamPermissionSelected: result,
      teamIdsSelected: results,
      teamSearchText: selectedGoal.name,
      for_0: selectedGoal.id,
      searchTeamEn: false,
    });
  }

  render() {
    const { t } = this.props;
    const { errors } = this.state;
    const isErrors = Object.keys(errors).length;
    return (
        <StyledModal
          className="aE-wobo-ui-modal"
          title={t('Create Workstream')}
          id="create-ws-wobo-modal"
          isOpen
          onDismiss={this.closeWorkstream}
          onSubmit={this.saveWs}
          submitLabel={t('Save')}
          style={{ zIndex: '1000001' }}
          disableScrollLock
        >
          <div className="headWsContent">
            <div id="display" />
            <div className="firstWsDiv">
              <div className="wsName">
                <input type="hidden" name="for_0" value={this.state.for_0} />
                <div>
                <Textfield
                  autoComplete="off"
                  helperText={isErrors && (typeof errors.showTagErr !== 'undefined')
                    ? this.state.boardName
                    : ''}
                  isError={isErrors || false}
                  isRequired
                  label={t("Name of new Workstream")}
                  name="tag"
                  style={{width: '415px'}}
                  onChange={this.handleChange}
                  type="text"
                  value={this.state.tag}
                />
                </div>
                <div style={{ marginTop: '25px' }}>
                <Textarea
                  autoComplete="off"
                  label={t("Workstream details")}
                  onChange={this.handleChange}
                  minRows={2}
                  maxRows={2}
                  name="goal"
                  style={{width: '415px'}}
                  type="text"
                  value={this.state.goal}
                />
                </div>
                <div className="wsTeamSec" id="wsTeamSec-label-searchTeam">
                {t("What team(s) is this workstream for")}? &nbsp;
                  <span className="startWs">*</span>
                </div>
                <div className="">
                  <div className="inLineBlk teamSearchs aETeamHead">
                    <div
                      aria-labelledby="wsTeamSec-label-searchTeam"
                      className="wsTeamSelect truncate"
					            tabIndex={0}
                      onKeyDown={e => KeyDownEvent(e, 
                        () => {this.setState({ searchTeamEn: !this.state.searchTeamEn })}
                      )}
                      onClick={(event) => { this.setState({ searchTeamEn: !this.state.searchTeamEn }); }}
                    >
                      {this.state.teamSearchText}
                    </div>
                    {
                      this.state.searchTeamEn
                      && (
                      <div id="myTeam" className="myTeamDropDown dropdown-content-ws">
                        <input type="text" placeholder={t("Search for teams")} id="TeamSearch" className="aETeamSearch" onChange={(e) => this.changeSearchBox(e)} />
                        <div className="teamList">
                          {
                            this.state.filter && this.state.filter.Team && this.state.filter.Team.map((valTeam) => (
                              <div className="permissionContent">
                                <div className="myAlign" data-testid="myAlign">
                                  <input id={`teamWs_${valTeam.id}`} className="defaultUnCheck alignCheck singleLine" onClick={(e) => this.handleAlignChange(e, valTeam)} type="checkbox" defaultChecked={!!this.state.teamPermissionSelected.find((val) => val.id == valTeam.id)} />
                                  <label htmlFor={`teamWs_${valTeam.id}`} />
                                  <div className="handCur truncate singleLine" onClick={(e) => { this.handleAlignChange(e, valTeam); }}>{valTeam.name}</div>
                                </div>
                              </div>
                            ))
                          }
                        </div>


                      </div>
                      )
                    }
                    {isErrors && (typeof errors.team_name !== 'undefined') ? <div className="goal-error-msg">{errors.team_name}</div> : ''}
                  </div>


                </div>
                <div className="inLineBlk">
                  {
                  isErrors && (typeof errors.showTeamErr !== 'undefined')
                    ? (
                      <div className="wsTeamErr">
                        <div className="outline-error_outline-14px-red" />
                        <div className="Board-target">
                          &nbsp;
                          {this.state.teamNameErr}
                        </div>
                      </div>
                    )
                    : ''
                    }
                </div>
              </div>
              <div className="chooseBoard">
                <fieldset>
                  <legend className="chooseBoardText">{t("Choose type of board")}:  </legend>
                  <div role="radiogroup" id={this.radioGroupID}>
                    <div className="wsBoardRadioStd">
                      <div
                        role="radio"
                        aria-checked={(this.state.board_type_0 == 1)}
                        aria-labelledby="ae-edit-std-flow-ws"
                        value="1"
                        tabIndex={(this.state.board_type_0 == 1) ? 0 : -1}
                        className={(this.state.board_type_0 == 1) ? "seleced-radio " : "empty-radio"}
                        name="board_type_0"
                        onClick={(e) => this.onSiteChanged(e, 1)}
                        onKeyDown={(e) => radioGroupHelper(this.radioGroupID,
                          () => this.onSiteChanged(e, 2), e)}
                        defaultChecked={this.state.board_type_0 == 1}
                      />
                      <label id="ae-edit-std-flow-ws" className="wsRadioWs">{t("Standard completion flow")}</label>
                    </div>
                    <div className="waStandardImg" />
                    <div className="wsBoardRadioCus">
                      <div
                        role="radio"
                        aria-checked={(this.state.board_type_0 == 2)}
                        aria-labelledby="ae-edit-cus-flow-ws"
                        className={(this.state.board_type_0 == 2) ? "seleced-radio " : "empty-radio"}
                        value="2"
                        tabIndex={(this.state.board_type_0 == 2) ? 0 : -1}
                        name="board_type_0"
                        onClick={(e) => this.onSiteChanged(e, 2)}
                        onKeyDown={(e) => radioGroupHelper(this.radioGroupID,
                          () => this.onSiteChanged(e, 1), e)}
                        defaultChecked={this.state.board_type_0 == 2}
                      />
                      <label id="ae-edit-cus-flow-ws" className="wsRadioWs">{t("Create your own custom flow")}</label>
                    </div>
                    <div className="waCustomImg" />

                    <div className="inLineBlk">
                      {
                        isErrors && (typeof errors.showBoardErr !== 'undefined')
                          ? (
                            <div className="krstarttargetError">
                              <div className="outline-error_outline-14px-red" />
                              <div className="Board-target">{this.state.selectBoard}</div>
                            </div>
                          )
                          : ''
                        }
                    </div>
                  </div>
                </fieldset>
              </div>

            </div>
          </div>
        </StyledModal>
    );
  }
}

export default withTranslation()(CreateWsPopUp);
